<template>
  <div>
    <div
      :class="{
        'tw-pointer-events-none tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center':
          coverContainer
      }"
      data-testid="studio-spinner"
    >
      <TablerLoader2
        :class="{
          'tw-animate-spin tw-text-deep-orange-500': true,
          'tw-h-4 tw-w-4': size === 'xxsmall',
          'tw-h-6 tw-w-6': size === 'xsmall',
          'tw-h-8 tw-w-8': size === 'small',
          'tw-h-12 tw-w-12': size === 'medium',
          'tw-h-16 tw-w-16': size === 'large'
        }"
      />
    </div>
    <div v-if="overlay" class="tw-fixed tw-left-0 tw-top-0 tw-z-40 tw-h-full tw-w-full tw-bg-white tw-opacity-50" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import TablerLoader2 from './Icons/tabler/TablerLoader2.vue';

export default defineComponent({
  name: 'StudioSpinner',
  components: { TablerLoader2 },
  props: {
    size: {
      type: String as PropType<'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large'>,
      default: 'medium'
    },
    coverContainer: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: false
    }
  }
});
</script>
